import styled from "styled-components";

export const Header = styled.header`
  width: 100%;
  display: flex;
  padding: 0 8px;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderTitle = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
`;

export const HeaderLeft = styled.div`
  width: 64px;
  display: flex;
  justify-content: flex-start;
`;

export const HeaderRight = styled.div`
  width: 64px;
  display: flex;
  justify-content: flex-end;
`;
